
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesItemsGrid extends Serenity.EntityGrid<POSSalesItemsRow, any> {
        protected getColumnsKey() { return 'Retail.POSSalesItems'; }
        protected getDialogType() { return POSSalesItemsDialog; }
        protected getIdProperty() { return POSSalesItemsRow.idProperty; }
        protected getInsertPermission() { return POSSalesItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesItemsRow.localTextPrefix; }
        protected getService() { return POSSalesItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }
        
    }
}